import React from 'react'
import PropTypes from 'prop-types'
import { UnitDisplay } from '@leverege/api-attributes'
import Util from './Util'

import { NumericInput } from '~/views'

export default class UnitEditor extends React.Component {

  static propTypes = {
    attribute : PropTypes.object,
    name : PropTypes.string,
    value : PropTypes.number,
    focus : PropTypes.bool,
    onChange : PropTypes.func.isRequired
  }

  constructor( props ) {
    super( props )
    this.onChange = Util.onChange.bind( this )
  }
  
  shouldComponentUpdate( nextProps, nextState ) {
    return false
  }

  render() {
    const { attribute : attr, value, focus } = this.props
    if ( attr == null ) {
      return <div />
    }
 
    return (
      <div>
        <NumericInput
          hint="Set value..."
          value={value}
          float
          focus={focus}
          changeOnBlur={false}
          min={attr.min}
          max={attr.max}
          onChange={this.onChange} />
        <label>{UnitDisplay.toDisplay( attr.base, attr )}</label>
      </div>
    ) 
  }
}
